import { combineReducers } from 'redux';
import MainReducer from './MainReducer';
import ProductReducer  from './ProductReducer';
import OrderReducer from './OrderReducer';
import SalesReportReducer from './SalesReportReducer';
import AuthReducer from './AuthReducer';
import StaffReducer from './StaffReducer';
import CustomerReducer from './CustomerReducer';
import VoucherReducer from './VoucherReducer';
import LoginReducer from './LoginReducer';
import HolidayReducer from './HolidayReducer';
import QuoteReducer from './QuoteReducer'

export default combineReducers({
    main: MainReducer,
    auth: AuthReducer,
    product: ProductReducer,
    order: OrderReducer,
    voucher: VoucherReducer,
    staff: StaffReducer,
    customer: CustomerReducer,
    sales: SalesReportReducer,
    login: LoginReducer,
    holiday : HolidayReducer,
    quote : QuoteReducer,
});
